// client/src/components/AboutArea.js

import React from 'react';
import { STRAPI_CMS_URL } from '../utils/Utils.js';
import { useAboutArea } from '../utils/fetchContent';
import LoadingSpinner from './LoadingSpinner.js';

function AboutArea() {
    
    const pageContent = useAboutArea();

    if (!pageContent) {
        return <LoadingSpinner message={"Lade About..."} />;  // Wait for the content to load
    }
    
    return (    
        <section className="about-area">    
            <div className="container">
                <div className="about-inner">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-46 order-0 order-lg-2">
                            <div className="about-img text-end">
                                {!pageContent.image?.data ? <div/> : <img src={STRAPI_CMS_URL + pageContent.image.url} alt=""/>}
                            </div>
                        </div>
                        <div className="col-75">
                            <div className="about-content">
                                <div className="section-title mb-3">
                                    <span className="sub-title">{pageContent.subTitle}</span>
                                    <h1 className="title">{pageContent.title}</h1>
                                </div>
                                <p>{pageContent.content}</p>
                                <ul className="list-wrap">
                                    <li>
                                        
                                        <div className="icon">
                                            {!pageContent.entry1Icon ? <div/> : <img src={STRAPI_CMS_URL + pageContent.entry1Icon.url} alt=""/>}
                                        </div>
                                        <div className="content">
                                            <h4 className="title">{pageContent.entry1Title}</h4>
                                            <p>{pageContent.entry1Content}</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="icon">
                                            {!pageContent.entry2Icon ? <div/> : <img src={STRAPI_CMS_URL + pageContent.entry2Icon.url} alt=""/>}
                                        </div>
                                        <div className="content">
                                            <h4 className="title">{pageContent.entry2Title}</h4>
                                            <p>{pageContent.entry2Content}</p>
                                        </div>
                                    </li>
                                </ul>
                                <div className="about-content-bottom">
                                    <span>Bugs oder Rechenfehler entdeckt? Auf GitHub beitragen!</span>
                                    <div className="read-more-btn">
                                        <a className="btn" href="https://github.com/nbungu/BauphysikToolWPF" style={{cursor: 'none'}}><i className="fs-5 bi bi-github pe-3"/>GitHub Repo<span></span></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
)}

export default AboutArea